import { render, staticRenderFns } from "./wrapper.vue?vue&type=template&id=648e4dd6&"
import script from "./wrapper.vue?vue&type=script&lang=js&"
export * from "./wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ElementsSeguroCombinadaTooltip: require('/var/web/bet777.es/components/elements/seguro-combinada-tooltip.vue').default,SportradarBetassist: require('/var/web/bet777.es/components/sportradar/betassist.vue').default})
